import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapPaginatedResponseDataAs } from '../../../../logic/unwrapPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationMessages } from '../../requests/getApplicationMessages';

export const useApplicationMessages = (
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean; refetchOnMount?: boolean; staleTime?: number },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationMessages>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'messages', params],
    queryFn: () =>
      getApplicationMessages(constructGet, uuid, definitionName, params),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    keepPreviousData: true,
    refetchOnMount: options?.refetchOnMount ?? false,
    staleTime: options?.staleTime ?? 10000,
  });

  return {
    ...unwrapPaginatedResponseDataAs(data, refetch, 'messages'),
    ...rest,
  };
};
